import { useEffect, useRef, useState } from 'react';
import moment from 'moment';

const formatTime = (milliseconds) => {
  if (!Number.isFinite(milliseconds) || milliseconds <= 0) {
    return '00:00:00';
  }

  return moment.utc(milliseconds).format('HH:mm:ss');
};

export default function useExamTimer(initialMilliseconds, onTimeUp) {
  const [timeLeft, setTimeLeft] = useState(null);
  const onTimeUpRef = useRef(onTimeUp);

  useEffect(() => {
    onTimeUpRef.current = onTimeUp;
  }, [onTimeUp]);

  useEffect(() => {
    if (!Number.isFinite(initialMilliseconds) || initialMilliseconds <= 0) {
      setTimeLeft(null);
      return undefined;
    }

    const startTime = Date.now();
    const endTime = startTime + initialMilliseconds;

    const update = () => {
      const remaining = endTime - Date.now();

      if (remaining <= 0) {
        setTimeLeft('Time Up!');
        onTimeUpRef.current();
        return false;
      }

      setTimeLeft(formatTime(remaining));
      return true;
    };

    update();

    const intervalId = setInterval(() => {
      if (!update()) {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [initialMilliseconds]);

  return timeLeft;
}

export { formatTime };
